import { FileLink, FileUpload } from './File';
import { LicensePlate, Vehicle } from './Vehicle';
import { Location } from './Location';
import { Property } from './Property';
import { Tenant } from './Tenant';
import { Violation } from './Violations';
import { Contact } from './Contact';
import { UnixTimestampMS } from './Time';
import { DigitalSignature } from './DigitalSignature';

export interface Job {
  id: number;
  externalID?: string;
  propertyID: number;
  property: Property;
  propertyName?: string;
  tenantID: number;
  tenant: Tenant;
  createdByUserID: number;
  createdByUserName: string;
  requestTime: Date;
  contactPhone: string;
  vehicle?: Vehicle;
  location: Location;
  plate?: LicensePlate;
  fileUploads?: Array<FileUpload>;
  files?: Array<FileLink>;
  status: string | TagStatus | TowStatus | PatrolStatus;
  type: JobType;
  created: Date | string;
  updated: Date | string;
  data: JobData;
  signatures?: Array<DigitalSignature>;
}

export interface CreateJobBody {
  propertyID: number;
  tenantID: number;
  createdByUserID: number;
  createdByUserName: string;
  requestTime: string | null;
  vehicle: Partial<Vehicle> | null;
  location: Location | null;
  type: JobType;
  contactPhone: string;
  violations: Array<Violation>;
  statuses: Array<JobStatus>;
  fileKeys: Array<string>;
  signatureFileKey?: string;
  notes: string | null;
  landmark: string | null;
}

export interface JobStatus {
  status: JobStatuses;
  timestamp: UnixTimestampMS;
  displayTime?: Date;
  reason?: string;
  location?: Location;
  contact?: Contact;
}

export enum JobType {
  NONE = '',
  BOOT = 'boot',
  TAG = 'tag',
  TOW = 'tow',
  PATROL = 'patrol',
}

export interface JobData {
  notes?: string;
  violations?: Array<Violation>;
  statuses?: Array<JobStatus>;
  contactPhone?: string;
  landmark?: string;
}

export interface JobReportDateRange {
  startDate: Date;
  endDate: Date;
}

export type JobStatuses = string | TagStatus | TowStatus | PatrolStatus;

export enum TagStatus {
  PENDING_APPROVAL = 'pending_approval',
  ACTIVE = 'active',
  DENIED = 'approval_denied',
  EXPIRED = 'expired',
  CANCELLED = 'cancelled',
  ENFORCED = 'enforced',
}

export enum PatrolStatus {
  STARTED = 'started',
  COMPLETE = 'complete',
}

export enum TowStatus {
  PENDING_APPROVAL = 'pending_approval',
  DENIED = 'approval_denied',
  REQUESTED = 'requested',
  RECEIVED = 'received',
  COMPLETE = 'complete',
  CANCELLED = 'cancelled',
  ACKNOWLEDGED = 'acknowledged',
  ENROUTE = 'enroute',
  ARRIVED = 'arrived',
  HOOKED = 'hooked',
  DROPPED = 'dropped',
}
